import { fmhNpiAPI, PRESCRIBERS_API_URL } from 'api/APIBase';

/**
 * Gets referral history for the currently logged in user
 */
export async function getReferralHistory() {
    const url = `${PRESCRIBERS_API_URL}/referrals`;
    return fmhNpiAPI({ url }).get().json();
}
